export default __webpack_public_path__ + "static/media/onboarding-3.0f779528.jpg";